export default "/assets/1eabf49dc6306193.png"